import { useShowFaceStack } from './useShowFaceStack'

export const useFooterViewClasses = () =>
  useShowFaceStack()
    ? { desktop: 'd-none d-md-flex', mobile: 'd-flex d-md-none' }
    : undefined
